module.exports = __webpack_public_path__ + "static/media/thumbnail.06cb50c3.jpg";